const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the manger activity timeline component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze injected to gain access to Analyze Resource
 * @argument {Content} Content injected to gain access to Content Resource
 * @argument {Tracks} Tracks injected to gain access to Tracks Resource
 * @argument {Events} Events injected to gain access to Events Resource
 * @argument {$q} $q injected to gain access to the $q promise module
 */
app.directive('managerActivity', ['Application', '$q', 'Analyze', 'Users', 'Viewables', '$translate', function(Application, $q, Analyze, Users, Viewables, $translate) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        type: '@',
        subset: '=',
        content: '='
      },
      template: require('../../../templates/directives/manager/manager-activity.html'),
      controller: ['$scope', function($scope) {
          var self = this;
          self.users = {};
          self.timelineLength = 15;
          self.directory = {};
          self.showItems = [];
          self.showMore = false;
          self.translations = {};
          self.tenseBlock = {
            'views': 'viewed',
            'shares': 'shared',
            'likes': 'liked'
          };
          self.gonePhrase = {
            'article': self.translations['managerActivity.an_article'],
            'video': self.translations['managerActivity.a_video'],
            'file': self.translations['managerActivity.a_file'],
            'track': self.translations['managerActivity.a_track'],
            'scorm-content': self.translations['managerActivity.a_scorm_content'],
            'event': self.translations['managerActivity.an_event'],
            'quiz': self.translations['managerActivity.a_quiz'],
            'imported_content': self.translations['managerActivity.vendor_content'],
            'presentation': self.translations['managerActivity.a_presentation']
          };

          self.goTo = function(item) {
            if (!item || !item.contentType || !item.contentId) {
              return;
            }
            var route = item.contentType + 's';
            if (item.contentType === 'quiz') {
              route = 'quizzes';
            } 
            if (item.contentType === 'scorm-content') {
              route = 'scorm';
            }
            if (item.contentType === 'imported_content') {
              route = 'imported-content';
            }
            Application.navigation.goTo('/view/' + route + '/' + item.contentId);
          };

          self.showMoreItems = function() {
            self.showMore = false;
            self.showItems = self.activeItems;
          };

          self.initialize = function() {
            if (!$scope.subset || !$scope.subset.length) {
              return;
            }
            if ($scope.type === 'content' && !$scope.content) {
              return;
            }
            self.loading = true;
            var items = ['views', 'shares', 'likes'];
            var promises = [];
            var contentList = {viewables: []};
            self.users = {};

            self.userList = $scope.subset.join(',');

            for (var i = 0; i < items.length; i++) {
              promises.push(Analyze.userRecent5({
                subresource: items[i],
                content: $scope.content,
                user_list: self.userList
              }).$promise);
            }

            // Get from analyze
            $q.all(promises)
            .then(function(data) {
              var newest;
              var activeItems = [];
              var PositionState = function() {
                return {
                  position: null,
                  setPosition: function(i) {
                    this.position = i;
                  },
                  getPosition: function() {
                    return this.position;
                  }
                };
              };

              positionState = new PositionState();
              var usersToGet = {};

              for (var i = 0; i < self.timelineLength; i++) {
                for (var j = 0; j < items.length; j++) {
                  if (!data[j][0]) {
                    continue;
                  }
                  // set position to the first available item
                  if (positionState.getPosition() === null) {
                    positionState.setPosition(j);
                    continue;
                  }
                  // check if each subsequent item is newer than the previous
                  if (new Date(data[j][0].created_on) > new Date(data[positionState.getPosition()][0].created_on)) {
                    positionState.setPosition(j);
                  }
                }
                var checkPosition = positionState.getPosition();
                if (checkPosition !== null) {
                  // add item type to timeline item and push to stack
                  data[checkPosition][0].itemType = items[checkPosition];
                  activeItems.push(data[checkPosition].shift());
                  var currentItem = activeItems[activeItems.length - 1];
                  currentItem.formattedDate = moment(currentItem.created_on).fromNow();
                  if (currentItem.user && !self.users[currentItem.user]) {
                    usersToGet[currentItem.user] = true;
                  }
                  if (currentItem.type && currentItem.document) {
                    currentItem.contentId = currentItem.document;
                    currentItem.contentType = currentItem.type;
                    contentList.viewables.push({type: currentItem.contentType, id: currentItem.document});
                  }
                  if (currentItem.content_type && currentItem.content) {
                    currentItem.contentId = currentItem.content;
                    currentItem.contentType = currentItem.content_type;
                    if(currentItem.content_type === 'scorm') {
                      currentItem.contentType = 'scorm-content';
                    }
                    contentList.viewables.push({type: currentItem.contentType, id: currentItem.content});
                  }
                  positionState.setPosition(null);
                  continue;
                }
                break;
              }

              self.activeItems = activeItems;
              if (activeItems.length > 5) {
                self.showItems = activeItems.slice(0, 5);
                self.showMore = true;
              } else if (activeItems.length > 0) {
                self.showItems = activeItems.slice(0);
              }

              var userIds = Object.keys(usersToGet);
              if (userIds.length) {
                Users.find({_id: '$in,' + userIds.length + ',' + userIds.join(','), fields: '_id,first_name,last_name,full_name,email'}).$promise
                .then(function(users) {
                  users.forEach(function(user) {
                    self.users[user._id] = user;
                  });
                })
              };

              Viewables.titles({}, contentList).$promise
              .then(function(data) {
                data.forEach(function(item) {
                  self.directory[item.id] = item;
                });
                self.loading = false;
              });
            });
          };

          if ($scope.subset) {
            self.initialize();
          }

          $scope.$watch('subset', function(newVal, oldVal) {
            if (newVal !== oldVal) {
              self.initialize();
            }
          }, true);

          if ($scope.type === 'content') {
            $scope.$watch('content', function(newVal, oldVal) {
              if (newVal !== oldVal) {
                self.initialize();
              }
            });
          };

          $translate([
            'managerActivity.viewed',
            'managerActivity.shared',
            'managerActivity.liked',
            'managerActivity.an_article',
            'managerActivity.a_video',
            'managerActivity.a_file',
            'managerActivity.a_track',
            'managerActivity.a_scorm_content',
            'managerActivity.an_event',
            'managerActivity.a_quiz',
            'managerActivity.vendor_content',
            'managerActivity.a_presentation'
          ]).then(function (translations) {
            self.translations = translations;
          });

        }],
      controllerAs: 'timeline'
    };
  }]);
